import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, AlertTriangle } from 'lucide-react';

function Disclaimer() {
  const navigate = useNavigate();

  return (
    <div className="page" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
      <button onClick={() => navigate('/')} className="btn btn-ghost" style={{ marginBottom: '2rem' }}>
        <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} /> Back to Home
      </button>

      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
        <AlertTriangle size={40} color="#FB923C" />
        <h1 style={{ fontSize: '2.5rem' }}>Disclaimer</h1>
      </div>
      
      <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#D1D5DB' }}>
        <p style={{ marginBottom: '1.5rem' }}><strong>Last Updated:</strong> January 2025</p>
        
        <div className="alert alert-warning" style={{ marginBottom: '2rem' }}>
          <strong>Important Notice:</strong> Please read this disclaimer carefully before using Astrowins services.
        </div>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>1. Nature of Services</h2>
        <p style={{ marginBottom: '1rem' }}>Astrowins provides insights based on ancient systems of Numerology, Vastu Shastra, and Vedic Astrology. These are offered as <strong>guidance and pattern recognition tools</strong>, not absolute predictions or medical/legal advice.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>2. No Guarantees</h2>
        <p style={{ marginBottom: '1rem' }}>We do not guarantee:</p>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Specific outcomes or life events</li>
          <li>Success in relationships, career, or finances</li>
          <li>Prevention of health issues or accidents</li>
          <li>Accuracy of timing predictions</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>3. Medical & Legal Advice</h2>
        <p style={{ marginBottom: '1rem' }}>Astrowins does NOT provide medical, legal, or financial advice. Always consult qualified professionals for:</p>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Health concerns → Consult doctors</li>
          <li>Legal matters → Consult lawyers</li>
          <li>Financial decisions → Consult financial advisors</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>4. User Responsibility</h2>
        <p style={{ marginBottom: '1rem' }}>You are solely responsible for decisions made based on Astrowins analyses. Use insights as one of many factors in your decision-making process.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>5. Vastu Remedies</h2>
        <p style={{ marginBottom: '1rem' }}>Vastu remedies suggesting construction/demolition are recommendations only. Always consult structural engineers and architects before making building modifications.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>6. Astrological Predictions</h2>
        <p style={{ marginBottom: '1rem' }}>Planetary transits and Dasha predictions are based on traditional Vedic astrology. Individual experiences may vary. These should be viewed as potential tendencies, not certainties.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>7. AI-Generated Content</h2>
        <p style={{ marginBottom: '1rem' }}>Some insights are generated using AI technology. While we strive for accuracy, AI responses should be considered as supportive guidance alongside traditional astrological principles.</p>

        <p style={{ marginTop: '2rem', padding: '1.5rem', background: 'rgba(59, 130, 246, 0.1)', borderRadius: '8px', borderLeft: '4px solid #3B82F6' }}>
          <strong>By using Astrowins, you acknowledge that you have read, understood, and agree to this disclaimer.</strong>
        </p>
      </div>
    </div>
  );
}

export default Disclaimer;